import React from "react";
import Code from "./Code";

const RawCode = props => <Code {...props} raw />;

export default RawCode;
